import React from "react";
// import {loaderHOC} from "../../logic/loader";
// class Loader extends React.Component {
//   constructor(props) {
//     super();
//     // this.loaderId = props.setLoader();
//   }
//   componentDidMount() {
//     // document.body.classList.toggle("loading", true);
//   }
//   componentWillUnmount() {
//     // document.body.classList.remove("loading");
//     // this.props.removeLoader(this.loaderId);
//   }
//   render() {
//   }
// }

export default function Loader() {
  return (<div className="loader-container">
    <div className="loader">
      {/* <div className="load-bar">
        <div className="bar"/>
        <div className="bar"/>
        <div className="bar" />
      </div> */}
    </div>
  </div>);
}
